<template>
  <div
    class="custom-scrollbar col-span-2 mt-md grid grid-cols-2 gap-3xl overflow-y-scroll rounded-md bg-white p-lg"
  >
    <slot></slot>
  </div>
</template>
